import PravoEuDetailRow from './PravoEuDetailRow';

export default PravoEuDetailRow;
